import styled from 'styled-components';
import rmq from 'styled-rmq';

export default styled.code`
	margin: 0 1rem;
	background: ${props => props.theme.gray1};
	font-family: monospace;
	color: #5b5b5b;
	font-size: 1rem;
	padding: 0.3rem 0.5rem;
	transform: rotateZ(28deg);
	font-style: italic;

	${rmq('485')},
	${rmq('ml')} {
		display: none;
	}
`;
